import { Component, OnInit, Input, ViewChild, HostListener } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatTableDataSource,
  MatPaginator,
  MatSort,
  MatTable,
  PageEvent
} from '@angular/material';
import { UserService } from '../_service/user.service';
import { ProductService } from '../_service/product.service';
import { AlertifyService } from '../_service/alertify.service';
import { ProductLocationComponent } from '../product-location/product-location.component';
import { CreateProductComponent } from './create-product/create-product.component';
import { InventoryDetailComponent } from './inventory-detail/inventory-detail.component';
import { ExportListComponent } from './exportList/exportList.component';
import { LocationService } from '../_service/location.service';
import { Subject } from 'rxjs';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { ProductInventorySearch } from '../_models/ProductInventorySearch';
import { Pagination } from '../_models/pagination';
import { PaginationService } from '../_service/pagination.service';
import { InventoryVendorapiDetailComponent } from './inventory-vendorapi-detail/inventory-vendorapi-detail.component';
import { TreeComponent } from 'src/app/tree/tree.component';

import { AuthService } from '../_service/auth.service';
import { Whmis2015Service } from '../_service/whmis2015.service';
import { EditProductComponent } from './edit-product/edit-product.component';
import { DeleteConfirmationComponent } from './edit-product/deleteConfirmation/deleteConfirmation/deleteConfirmation.component';
import { ComponentFixture } from '@angular/core/testing';

export class TodoItemNode {
  authorityUnitId: number;
  parentAuthorityUnitId: number;
  rootAuthorityUnitId: number;
  name: string;
  children?: TodoItemNode[];
  hasChild: boolean;
  exists: boolean;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  authorityUnitId: number;
  parentAuthorityUnitId: number;
  rootAuthorityUnitId: number;
  item: string;
  level: number;
  expandable: boolean;
  checked: boolean;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'inventory-product',
  templateUrl: './inventory-product.component.html',
  styleUrls: ['./inventory-product.component.css']
})

export class InventoryProductComponent implements OnInit {

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private productService: ProductService,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    private locationService: LocationService,
    public paginationService: PaginationService,
    private whmisService: Whmis2015Service,
  ) {
    if (this.products.body) {
      this.MyDataSource.data = this.products.body;
      this.MyDataSource.filterPredicate = this.tableFilter();
    }
  }

  searchString;
  searchResultIsEmpty = true;
  authorities;
  authArrayIds: any = [];
  MyDataSource: any;
  unsubscribe = new Subject<void>();

  selectionRequired: any = {};
  productAssignedSuccessfully: any = {};
  productLocationExists: any = {};
  removeSelection: any = {};
  backupSelectionRequired: any = {};
  noSDSInLocations: any = {};
  emptySearchResponse: any = {};
  emptyInventoryResponse: any = {};

  locationsFromResponse: any = [];
  location: TodoItemNode[] = [];
  parentLocations: any = ([] = []);
  childLocations: any = ([] = []);
  nodeIsChecked: any;

  disablePaging: boolean;

  physicalClass: any;
  healthClass: any;

  testhealhClassId: any;
  testhealthClassName: any;

  public selection = new SelectionModel<InventoryModel>(true, []);

  selectedd = new FormControl(null, [Validators.required]);

  loading = false;
  isOpen = false;
  assignLoading = false;

  backUpModel: any = {};

  value = '';

  selectedHazardClasses: any;

  backUpSDSFiles: any = [];
  selectedLocations: any = ([] = []);
  selectedLocationValues: any = ([] = []);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;


  @Input() totalCount: number;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Input() totalPages: number[];
  @Input() pageIndex: number = 0;
  @Input() pageSizeOptions: number[] = [5, 10, 20];
  @Input() pageSize: number;
  @Input() nextPage: number;
  @Input() previousPage: number;

  isLoading = false;
  hideButton = false;
  errorMessage = false;
  products: any = [];
  vendorProducts: any = [];
  allProducts: any = [];
  selectedProduct;
  selectedMfgOption;
  authorityId;

  passedId: any;
  healthClassArray: any;

  locations;
  locationArray;
  selected: number;
  myList: any = [];

  locationModel: any = {};

  healthClassArr: any = [];
  healthClassHazards: any;
  selectedHealthHazard: number;

  productInventorySearch: ProductInventorySearch[];
  productParams: any = {};

  message: any;
  removedMessage: boolean;

  model: any = {
    productId: null,
    rootAuthorityUnitId: null,
    productAuthorityId: null
  };

  assignModel: any = {};
  selectedLocationCheck: any = [];

  form = new FormGroup({
    inventorySearchControl: new FormControl({ value: '', disabled: false })
  });

  selectedSearchParameter;
  selectFormControl = new FormControl({ value: '', disabled: true }, [
    Validators.required
  ]);
  selectedParameter = 'none';

  locationList = new FormControl({ value: '', disabled: true }, [
    Validators.required
  ]);
  selectedAuth: number;
  locationId: any;

  productLocation;
  selectedParam: any;

  userDetail: any;
  sdsUserId: any;
  sdsUserIdNumber: number;

  sortDirection: any;

  selectedDropdown: any;

  productNameFilterIsClear: boolean;
  productCodeFilterIsClear: boolean;
  mfgNameFilterIsClear: boolean;
  casNoFilterIsClear: boolean;

  manufacturerFilter = new FormControl('');
  productCodeFilter = new FormControl('');
  casNumberFilter = new FormControl('');
  productNameFilter = new FormControl('');

  productNameFilterValue = '';
  mfgFilterValue = '';
  productCodeFilterValue = '';
  casNoFilterValue = '';


  filterValues = {
    product_name: '',
    mfg_detail: '',
    Revised: '',
    product_code: '',
    cas_no: '',
    LastVerified: ''
  };

  panelOpenState = false;

  // request: any;
  request = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    productName: '',
    productCode: '',
    manufacturer: '',
    casNumber: ''
  };

  userDetailArray = [];

  displayedColumns: string[] = [
    'product_name',
    'mfg_detail',
    'revision_date',
    'product_code',
    'exempt',
    'last_verified',
    'discontinued'
  ];

  hazardClassControl = new FormControl();

  hazardClassGroups: PokemonGroup[] = [
    {
      name: 'Health Hazard Class',
      hazardClass: [
        {name: 'HealthHazard', hazardId: 190, value: 'Acute toxicity'},
        {name: 'HealthHazard', hazardId: 191, value: 'Aspiration hazard'},
        {name: 'HealthHazard', hazardId: 192, value: 'Biohazardous Infectious Materials'},
        {name: 'HealthHazard', hazardId: 193, value: 'Carcinogenicity'},
        {name: 'HealthHazard', hazardId: 194, value: 'Germ cell mutagenicity'},
        {name: 'HealthHazard', hazardId: 195, value: 'Health Hazards Not Otherwise Classified'},
        {name: 'HealthHazard', hazardId: 196, value: 'Reproductive toxicity'},
        {name: 'HealthHazard', hazardId: 197, value: 'Respiratory or skin sensitization'},
        {name: 'HealthHazard', hazardId: 198, value: 'Serious eye damage/eye irritation'},
        {name: 'HealthHazard', hazardId: 199, value: 'Skin corrosion/irritation'},
        {name: 'HealthHazard', hazardId: 200, value: 'Specific Target Organ Toxicity - Repeated exposure'},
        {name: 'HealthHazard', hazardId: 201, value: 'Specific Target Organ Toxicity - Single exposure'},
      ]
    },
    {
      name: 'Physical Hazard Class',
      hazardClass: [
        {name: 'PhysicalHazard', hazardId: 279, value: 'Self-heating substances and mixtures'},
        {name: 'PhysicalHazard', hazardId: 280, value: 'Self-reactive substances and mixtures'},
        {name: 'PhysicalHazard', hazardId: 281, value: 'Combustible dusts'},
        {name: 'PhysicalHazard', hazardId: 282, value: 'Simple Asphyxiants'},
        {name: 'PhysicalHazard', hazardId: 283, value: 'Corrosive to metals'},
        {name: 'PhysicalHazard', hazardId: 284, value: 'Substances and mixtures which, in contact with water, emit flammable gases'},
        {name: 'PhysicalHazard', hazardId: 285, value: 'Flammable Aerosols'},
        {name: 'PhysicalHazard', hazardId: 286, value: 'Flammable Gases'},
        {name: 'PhysicalHazard', hazardId: 287, value: 'Flammable Liquids'},
        {name: 'PhysicalHazard', hazardId: 288, value: 'Flammable solids'},
        {name: 'PhysicalHazard', hazardId: 289, value: 'Gases under pressure'},
        {name: 'PhysicalHazard', hazardId: 290, value: 'Organic peroxides'},
        {name: 'PhysicalHazard', hazardId: 291, value: 'Oxidizing gases'},
        {name: 'PhysicalHazard', hazardId: 292, value: 'Oxidizing liquids'},
        {name: 'PhysicalHazard', hazardId: 293, value: 'Oxidizing solids'},
        {name: 'PhysicalHazard', hazardId: 294, value: 'Physical hazards not otherwise classified'},
        {name: 'PhysicalHazard', hazardId: 295, value: 'Pyrophoric gases'},
        {name: 'PhysicalHazard', hazardId: 296, value: 'Pyrophoric liquids'},
        {name: 'PhysicalHazard', hazardId: 297, value: 'Pyrophoric solids'},
      ]
    }
  ];

  dropDown = [
    { value: 'select', viewValue : 'Select' },
    { value: 'backupSDS', viewValue : 'SDS sheets' },
    { value: 'generateExcel', viewValue : 'Excel inventory list' }
  ];


  limitProductCodeChar(productCode) {
    // console.log(productCode);
    if (productCode.length > 30) {
      return productCode.substring(0, 27) + '...';
    } else {
      return productCode;
    }
  }

  selectAll(values) {
    const vals = [];
    for (const val of values) { 
      vals.push(val.hazardId+','+val.name);
    }
    if (this.hazardClassControl.value != null) {
      for(const val of this.hazardClassControl.value) {
        if (vals.indexOf(val) == -1) { vals.push(val); }
      }
    }
    this.hazardClassControl.setValue(vals);
  }

  deselectAll(values) {
    let vals = this.hazardClassControl.value;
    if (vals == null) {return;}
    for (const val of values) {
      const i = vals.indexOf(val.hazardId+','+val.name);
      if (vals[0] == null || vals[0] == undefined) { delete vals[0]; vals = []; }
      if (i != -1) {delete vals[i];}
    }
    this.hazardClassControl.setValue(vals);
    this.hazardClassControl.value.filter(a => a != undefined);
  }

  clearInputBox() {
    this.value = '';
    this.searchString = '';
    this.form.controls['inventorySearchControl'].setValue('');
    this.clearProductNameInputBox();
    this.clearMFGNameInputBox();
    this.clearProductCodeInputBox();
  }

  clearProductNameInputBox() {
    this.productNameFilterIsClear = true;
    this.productNameFilterValue = '';
    this.filterValues.product_name = '';
  }

  clearMFGNameInputBox() {
    this.mfgNameFilterIsClear = true;
    this.mfgFilterValue = '';
    this.filterValues.mfg_detail = '';
  }

  clearProductCodeInputBox() {
    this.productCodeFilterIsClear = true;
    this.productCodeFilterValue = '';
    this.filterValues.product_code = '';
  }

  physicalHazardClass() {
    return this.whmisService.getPhysicalClass().subscribe(res => {
      this.physicalClass = res;
    });
  }

  healthHazardClass() {
    return this.whmisService.getHealthClass().subscribe(res => {
      this.healthClass = res;
    });
  }

  HazardClassFilterFunction() {
    this.hazardClassGroups = [
      {
        name : 'Health Hazard Class',
        hazardClass : []
      },
      {
        name : 'Physical Hazard Class',
        hazardClass : []
      }
    ];
    this.whmisService.getPhysicalHazardClass().subscribe(
      res => {
        this.hazardClassGroups[1].hazardClass = res;
        // console.log(this.hazardClassGroups[1]);
      }
    );
    this.whmisService.getHealthHazardClass().subscribe(
      res => {
        this.hazardClassGroups[0].hazardClass = res;
        // console.log(this.hazardClassGroups[0]);
      }
    );
  }

  restrictFilterParams() {
    if (this.selectedParameter === 'none') {
      return false;
    }
    if (
      (this.selectedParameter === 'productName' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    }
    if (
      (this.selectedParameter === 'productCode' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    }
    if (
      (this.selectedParameter === 'manufacturer' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    } else {
      return true;
    }
  }


  tableFilter(): (data: any, filter: string) => boolean {
    const filterFunction = function(data, filter): boolean {
      // console.log(data);
      const searchTerms = JSON.parse(filter);

      if (searchTerms.mfg_detail !== '' && data.mfg_detail !== null) {
        return (
          data.mfg_detail.toString().indexOf(searchTerms.mfg_detail) !== -1
        );
      } else if (
        searchTerms.product_code !== '' &&
        data.product_code !== null
      ) {
        return (
          data.product_code.toLowerCase().indexOf(searchTerms.product_code) !==
          -1
        );
      } else if (searchTerms.product_name !== '') {
        return (
          data.product_name.toLowerCase().indexOf(searchTerms.product_name) !==
          -1
        );
      } else {
        return true;
      }
    };
    return filterFunction;
  }

  sortData(event) {
    this.sortDirection = event.direction;
    this.getAllProducts();
  }

  ngOnInit() {
    this.selectedParameter = 'productName';
    this.selectedSearchParameter = 'productName';
    this.disableSearchbox(); // Set initial disabled state
    this.getAllProducts();
    this.productNameFilterFunction();
    this.productCodeFilterFunction();
    this.manufacturerFilterFunction();
    this.HazardClassFilterFunction();
    console.log(this.locationTree);

    this.selectedDropdown = 'select';
    for (const id of this.selection.selected) {
      console.log(id);
      this.passedId = id.productId;
    }
    // get userid for location tree (for site admins)
    this.sdsUserId = this.authService.decodedToken.userid;
    this.sdsUserIdNumber = +this.sdsUserId;
  }

  setLoadingState = (isLoading) => {};


  // tslint:disable-next-line: use-life-cycle-interface
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // productCodeLimit(string) {
  //     if (string.length > 40) {
  //       return string.substring(0, 40) + '...';
  //     } else {
  //       return string;
  //     }
  // }

  openLocationTree1(test1) {
    console.log('Location Tree1: ' + test1._selection);
  }

  openLocationTree2(test2) {
    console.log('Location Tree2: ' + test2._selection);
  }

  createBackup(filterByLocationIds) {
    console.log('Selected SDS back up sheets');
    this.backUp(filterByLocationIds);
  }

  createExcelInventoryList(filterByLocationIds) {
    console.log('Selected Excel Inventory list');
    this.openExportList(filterByLocationIds);
  }

  selectedDropDown(userSelection, filterByLocationIds) {
    if (userSelection === 'backupSDS') {
      this.createBackup(filterByLocationIds);
    } else if (userSelection === 'generateExcel') {
      this.createExcelInventoryList(filterByLocationIds);
    }
}

  productNameFilterFunction() {
    this.productNameFilter.valueChanges
      .pipe(debounceTime(800))
      .subscribe(product_name => {
        this.filterValues.product_name = product_name.trim();
        this.filterValues.product_name = product_name.toLowerCase();
        if (this.products.body && this.filterValues.product_name.length !== 0) {
          this.MyDataSource.filter = JSON.stringify(this.filterValues);
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.getAllProducts();
        }
        if (this.products.body && this.productNameFilterIsClear) {
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.getAllProducts();
        }
      });
  }

  productCodeFilterFunction() {
    this.productCodeFilter.valueChanges
      .pipe(debounceTime(800))
      .subscribe(product_code => {
        this.filterValues.product_code = product_code.trim();
        this.filterValues.product_code = product_code.toLowerCase();
        if (this.products.body && this.filterValues.product_code.length !== 0) {
          this.MyDataSource.filter = JSON.stringify(this.filterValues);
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.getAllProducts();
        }
        if (this.products.body && this.productCodeFilterIsClear) {
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.getAllProducts();
        }
      });
  }

  manufacturerFilterFunction() {
    this.manufacturerFilter.valueChanges
      .pipe(debounceTime(800))
      .subscribe(mfg_detail => {
        this.filterValues.mfg_detail = mfg_detail.trim();
        this.filterValues.mfg_detail = mfg_detail.toLowerCase();
        if (this.products.body && this.filterValues.mfg_detail.length !== 0) {
          this.MyDataSource.filter = JSON.stringify(this.filterValues);
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.getAllProducts();
        }
        if (this.products.body && this.mfgNameFilterIsClear) {
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.getAllProducts();
        }
      });
  }

  onSelectParameter(event) {
    this.selectedSearchParameter = event.value;
  }

  disableSearchbox() {
    if (this.selectedParameter === 'none') {
      this.value = '';
      // this.searchString = '';
      this.form.controls['inventorySearchControl'].disable();
    } else {
      this.form.controls['inventorySearchControl'].enable();
    }
  }

  disableAssignButton(): boolean {
    if (
      this.locationTree.checklistSelection.hasValue() ||
      this.locationTree.itemSelected
    ) {
      return true;
    } else {
      return false;
    }
  }

  applyFilter(filterValue: string) {
    this.MyDataSource.filter = filterValue.trim().toLowerCase();
  }

  mfgFilter(mfgName) {
    const newArray: any = [];
    this.allProducts.filter(p => {
      if (p.mfg_name === mfgName) {
        console.log('mfgFilter ' + p.mfg_name + ' , ' + p.product_name);
        newArray.push(p);
      }
      this.MyDataSource = new MatTableDataSource();
      this.MyDataSource.data = newArray;
      this.MyDataSource.sort = this.sort;
      this.MyDataSource.paginator = this.paginator;
    });
  }

  openProductLocationPage(productId) {
    console.log('openProductLocationPage()' + productId);
    const dialogRef = this.dialog.open(ProductLocationComponent, {
      width: '1000px',
      data: {
        productId: productId
      }
    });
  }

  openProductEditPage(row) {
    const dialogRef = this.dialog.open(EditProductComponent, {
      width: '1030px',
      data: {
        product: row
      }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(res => {
      // returns true or false
      if (dialogRef.componentInstance.isModified) {
        this.getAllProducts();
      }
    });
  }

  public doFilter = (value: string) => {
    this.MyDataSource.filter = value.trim().toLocaleLowerCase();
  };

  restrictDropDownParams() {
    if (this.selectedParameter === 'productName' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedParameter === 'productCode' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedParameter === 'manufacturer' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    } else {
      return true;
    }
  }

  emptyParamError() {
    if (this.selectedParameter === 'productName' && (this.searchString === '' || this.searchString === undefined)) {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedParameter === 'productCode' && (this.searchString === '' || this.searchString === undefined)) {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedParameter === 'manufacturer' && (this.searchString === '' || this.searchString === undefined)) {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    } else {
      return true;
    }
  }

  invalidSearchResultMessage(message) {
    if (message) {
      this.message = message;
    } else {
      this.message = '';
    }
  }

  // tslint:disable-next-line: member-ordering
  pagination: Pagination;

  pageChanged(event: PageEvent) {
    this.totalItems = event.length;
    this.pageIndex = event.pageIndex;
    this.nextPage = event.pageSize;
    this.getAllProducts();
  }

  getAllProducts() {
    this.isLoading = true;
    this.setLoadingState(true);
    this.hideButton = true;
    this.pageSize = this.pageSizeOptions[1];

    const findObj: SearchCloudSDSObject = {
      productName: '',
      productCode: '',
      productCodeFilter: '',
      productNameFilter: '',
      mfgName: '',
      mfgNameFilter: '',
      none: '',
      hazardClasses: [],
      locationId: [],
      pageNumber: null,
      pageSize: null,
      sortDirection: ''
    };

    if (this.selectedSearchParameter === 'productName' && this.searchString !== undefined) {
      findObj.productName = this.searchString.trim();
    }
    if (this.filterValues.product_name !== '') {
      findObj.productNameFilter = this.filterValues.product_name.trim();
    }
    if (this.selectedSearchParameter === 'productCode' && this.searchString !== undefined) {
      findObj.productCode = this.searchString.trim();
    }
    if (this.filterValues.product_code !== '') {
      findObj.productCodeFilter = this.filterValues.product_code.trim();
    }
    if (this.selectedSearchParameter === 'manufacturer' && this.searchString !== undefined) {
      findObj.mfgName = this.searchString.trim();
    }
    if (this.filterValues.mfg_detail !== '') {
      findObj.mfgNameFilter = this.filterValues.mfg_detail.trim();
    }
    if (this.selectedParameter === 'none') {
      findObj.none = this.searchString;
    }

    findObj.hazardClasses = this.selectedHazardClasses;
    findObj.pageNumber = this.pageIndex;
    findObj.pageSize = this.nextPage;
    findObj.sortDirection = this.sortDirection;

    if (this.authService.decodedToken.role === 'Super Admin') {
      findObj.locationId = [];
      for (const loc of this.selectedLocations) {
        findObj.locationId.push(loc.authorityUnitId);
      }
    }
    if (this.authService.decodedToken.role === 'Site Admin') {
      findObj.locationId = [];
      for (const loc of this.selectedLocations) {
        if (loc.userId === this.sdsUserIdNumber) {
          findObj.locationId.push(loc.authorityUnitId);
        }
      }
    }

    // if (this.restrictDropDownParams()) {
      this.errorMessage = false;
      return this.productService
        .findInventoryProducts(findObj)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res: any) => {
            // this.selectedLocations = [];
            this.emptySearchResponse = res.headers.get('nosearchresult');
            this.emptyInventoryResponse = res.headers.get('noproducts');

            if (res.body) {
              this.products = res;
              // console.log(this.products.body);
              for (const response of this.products.body) {
                this.allProducts.push(response);
              }
              // console.log(this.products);
              this.currentPage = JSON.parse(
                res.headers.get('pagination')
              ).currentPage;
              this.itemsPerPage = JSON.parse(
                res.headers.get('pagination')
              ).itemsPerPage;
              this.totalItems = JSON.parse(
                res.headers.get('pagination')
              ).totalItems;
              this.totalPages = JSON.parse(
                res.headers.get('pagination')
              ).totalPages;

              this.isLoading = false;
              this.setLoadingState(false);

              this.MyDataSource = new MatTableDataSource<Element>(res);
              this.MyDataSource.data = res.body;
              this.MyDataSource.sort = this.sort;
              this.MyDataSource.filterPredicate = this.tableFilter();
              this.searchResultIsEmpty = false;
              this.disablePaging = false;

              // reset locationIds
              // this.selectedLocationCheck = [];
              // this.selectedLocations = [];

            } else if (this.emptySearchResponse) {
              this.invalidSearchResultMessage(this.emptySearchResponse);
              this.errorMessage = true;
              this.isLoading = false;
              this.setLoadingState(false);
              this.MyDataSource.data = [];
              this.searchResultIsEmpty = false;
              this.disablePaging = true;
            } else if (this.emptyInventoryResponse) {
              this.invalidSearchResultMessage(this.emptyInventoryResponse);
              this.errorMessage = true;
              this.isLoading = false;
              this.setLoadingState(false);
              this.searchResultIsEmpty = false;
              this.disablePaging = true;
            }
          },
          error => {
            this.searchResultIsEmpty = true;
            this.isLoading = false;
            this.setLoadingState(false);
          },
          () => {
            this.isLoading = false;
            this.setLoadingState(false);
          }
        );
    // }
  }

  searchFilterProducts(value: string) {
    this.searchString = value;
  }

  searchForProducts(selectedValue: string) {
    this.allProducts = [];
    this.sortDirection = null;
    this.searchString = selectedValue;
    const searchObj: searchObject = {
      searchProductName: '',
      searchProductCode: '',
      searchMfgName: '',
      searchCasNumber: ''
    };
    if (this.selectedSearchParameter === 'productName') {
      searchObj.searchProductName = selectedValue.trim().toLowerCase();
    }
    if (this.selectedSearchParameter === 'productCode') {
      searchObj.searchProductCode = selectedValue.trim().toLowerCase();
    }
    if (this.selectedSearchParameter === 'manufacturer') {
      searchObj.searchMfgName = selectedValue.trim().toLowerCase();
    }
    if (this.restrictDropDownParams()) {
    this.paginator.firstPage();
    this.getAllProducts();
    }
  }

  selectedHazardClass() {
    this.selectedHazardClasses = this.hazardClassControl.value.filter(a => a != undefined);
    this.selectAll(this.selectedHazardClasses);
    this.getAllProducts();
  }

 // filter by location function
  filterByLocation(filterLocationIds) {
    console.log(filterLocationIds);
    Array.from(filterLocationIds.checklistSelection._selection.entries())
    .forEach(entry => this.selectedLocationCheck = entry[0]);

    if (this.selectedLocationCheck.authorityUnitId !== undefined || this.selectedLocationCheck.length !== 0) {
      this.selectedLocations = filterLocationIds.checklistSelection._selection;
      this.paginator.firstPage();
      this.getAllProducts();
    } else {
      this.getAllProducts();
    }
  }

  treeValueChange(filterLocationIds) {
    Array.from(filterLocationIds.checklistSelection._selection.entries())
     .forEach(entry => this.selectedLocationCheck = entry[0]);
     console.log(this.selectedLocationCheck);
     if (this.selectedLocationCheck.authorityUnitId !== undefined || this.selectedLocationCheck.length !== 0) {
       this.selectedLocations = filterLocationIds.checklistSelection._selection;
       // if (this.emptyParamError()) {
       this.getAllProducts();
       // }
     }
   }
 

  isExpanded() {
    if (this.selectedLocations.length !== 0) {
      return true;
    } else {
      return false;
    }
  }

  searchProductName(searchBoxProductName: string) {
    this.allProducts = [];
    this.searchString = searchBoxProductName;
    let searchObj: searchObject = {
      searchProductName: '',
      searchProductCode: '',
      searchMfgName: '',
      searchCasNumber: ''
    };

    searchObj.searchProductName = searchBoxProductName;
    searchObj.searchProductCode = '';
    searchObj.searchMfgName = '';
  }

  openProductCreationPage() {
    const dialogRef = this.dialog.open(CreateProductComponent, {
      width: '1030px'
    });

    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (dialogRef.componentInstance.isModified) {
        this.getAllProducts();
      }
    });
  }

  openInventoryDetailPage(row) {
    const dialogRef = this.dialog.open(InventoryDetailComponent, {
      width: '1030px',
      data: {
        product: row
      }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      // returns true or false
      if (dialogRef.componentInstance.isModified) {
        this.getAllProducts();
      }
    });
  }

  openVendorAPIDetailPage(product) {
    const dialogConfig = new MatDialogConfig();
    const dialogRef = this.dialog.open(InventoryVendorapiDetailComponent, {
      width: '1000px',
      data: {
        row: product
      }
    });

    dialogConfig.data = {
      ref_id: product['ref_id'],
      msdsId: product['msds_id'],
      internal: product['internal']
    };
  }

  openDiaglogProductPage(row) {
    const dialogConfig = new MatDialogConfig();
    if (row['exemptionclassFlag'] == '1') {
      row['exemptionclassFlag'] = 'true';
    } else {
      row['exemptionclassFlag'] = 'false';
    }
    dialogConfig.data = {
      // product_name: row['product_name'],
      product_name: row['product_name'],
      mfg_name: row['mfg_name'],
      product_code: row['product_code'],
      cas_no: row['cas_no'],
      productAlias: row['productAlias'],
      health_authority: row['health_authority'],
      productNodes: row['productNote'], // not needed
      additionalSupplier: row['additionalSupplier'],
      whmisExempt: row['whmis_exempt'],
      last_verified: row['last_verified'],
      revision_date: row['revision_date'],
      date_added: row['date_added'],
      discontinued: row['discontinued'],
      // secondaryName: row['secondaryName'],
      fromVendorApi: row['fromVendorAPI']
    };

    // const dialogRef = this.dialog.open(ProductPageComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProductLocationComponent, dialogConfig);
    this.selectedProduct = row;
    // console.log("selected product " + this.selectedProduct.internal + ' cas ' + this.selectedProduct.cas_no);

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  selectRow(row) {
    console.log(row);
    if (this.authService.decodedToken.role === 'Super Admin') {
      this.openProductEditPage(row);
    } else if (this.authService.decodedToken.role === 'Site Admin') {
      this.openInventoryDetailPage(row);
    }
  }

  editClick(product) {
    return this.productService
      .updateProduct(product.productId, product)
      .subscribe(
        res => {
          this.products = res;
          this.products.forEach(element => {
            this.allProducts.push(element);
          });

          this.MyDataSource = new MatTableDataSource();
          this.MyDataSource.data = this.allProducts;
          this.MyDataSource.sort = this.sort;
          this.MyDataSource.paginator = this.paginator;
        },
        error => {
          console.log('There was an error: ' + error);
        }
      );
  }

  searchBoxClick(searchBoxValue: string) {
    this.searchString = searchBoxValue;
    this.getAllProducts();
    this.allProducts = [];
  }

  openExportList(filterLocationIds) {
    this.selectedLocations = filterLocationIds.checklistSelection._selection;

    const dialogRef = this.dialog.open(ExportListComponent, {
      width: '1000px',
      data: {
        productId: this.selection.selected,
        locations: this.selectedLocations
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (dialogRef.componentInstance.isModified) {
        this.selectedDropdown = 'select';
        this.selectedLocations.clear();
      }
      this.selectedDropdown = 'select';
      this.selectedLocations.clear();
    });
  }

  // selectAllLocations() {
  //   return this.locationTree.checkAll();
  // }

  // deselectAllLocations() {
  //   return this.locationTree.deselectAll();
  // }

  backUp(filterLocationIds) {
    this.loading = true;
    this.isLoading = true;
    this.setLoadingState(true);
    this.backUpSDSFiles = [];

    this.backUpModel.ProductId = [];
    if ((this.searchString !== undefined && this.searchString !== '') ||
     this.filterValues.product_name !== '' || this.filterValues.product_code !== '' || this.filterValues.mfg_detail !== '') {
      for (const obj of this.MyDataSource.data) {
        this.backUpModel.ProductId.push(obj.productId);
      }
    }

    this.selectedLocations = filterLocationIds.checklistSelection._selection;

    // super admin location tree/location ID
    if (this.authService.decodedToken.role === 'Super Admin') {
      this.backUpModel.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
          this.backUpModel.LocationId.push(loc.authorityUnitId);
      }
    }

    if (this.authService.decodedToken.role === 'Site Admin') {
      this.backUpModel.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
        if (loc.userId === this.sdsUserIdNumber) {
          this.backUpModel.LocationId.push(loc.authorityUnitId);
        }
      }
    }

    this.productService
      .createArchive(this.backUpModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        blob => {
          console.log(this.selection);

          this.removeSelection = blob.headers.get('selectionremoval');
          this.backupSelectionRequired = blob.headers.get('selectionrequired');
          this.noSDSInLocations = blob.headers.get('noSDSFiles');
          if (this.removeSelection) {
            this.alertify.message(this.removeSelection);
            // this.isLoading = false;
            this.loading = false;
            this.isLoading = false;
            this.setLoadingState(false);
          } else if (this.noSDSInLocations) {
            this.alertify.message(this.noSDSInLocations);
            this.loading = false;
            this.isLoading = false;
            this.setLoadingState(false);
            // this.selection.clear();
            this.selectedLocations.clear();
            this.selectedDropdown = 'select';
          } else if (this.backupSelectionRequired) {
            this.alertify.message(this.backupSelectionRequired);
            this.loading = false;
            this.isLoading = false;
            this.setLoadingState(false);
            this.selectedDropdown = 'select';
          } else {
            const link = document.createElement('a');
            // link.href = window.URL.createObjectURL(blob.body);
            // link.download = 'SDS_Backup';
            // link.click();
            if (window.navigator &&
              window.navigator.msSaveOrOpenBlob) { // for IE
              window.navigator.msSaveOrOpenBlob(blob.body, 'SDS_Backup' + `.zip`);
            } else { // for Chrome
            link.href = window.URL.createObjectURL(blob.body);
            link.download = 'SDS_Backup';
            link.click();
            }
            this.alertify.success('Backup created');
            this.loading = false;
            this.isLoading = false;
            this.setLoadingState(false);
            this.hideButton = false;
            this.backUpSDSFiles = [];
            // clears selected location/locations
            this.selectedLocations.clear();
            // clears selected product/products
            this.selection.clear();
            this.clearInputBox();
            this.selectedDropdown = 'select';
          }
        },
        error => {
          this.alertify.error('Something went wrong, please try again');
          this.isLoading = false;
          this.setLoadingState(false);
          this.loading = false;
          this.hideButton = false;
          this.backUpSDSFiles = [];
          this.selectedDropdown = 'select';
        }
      );
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    if (numSelected === 0) {
      return null;
    }
    const numRows = this.MyDataSource.data.length;
    return numSelected === numRows;
  }
  
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
      this.isAllSelected()
        ? this.selection.clear()
        : this.MyDataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: InventoryModel): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${
      this.selection.isSelected(row) ? 'deselect' : 'select'
    } row ${row.position + 1}`;
  }

  // getTopLocations() {
  //   return this.locationService
  //     .locationHiararchy()
  //     .pipe(takeUntil(this.unsubscribe))
  //     .subscribe(res => {
  //       this.locationsFromResponse = res;
  //       this.location = this.locationsFromResponse;
  //     });
  // }

  clickedActive(element) {
    element.checked = !element.checked;
    console.log(element.checked);
  }
}

export interface ProductInterface {
  product_name: string;
  mfg_name: string;
  // secondaryName: string;
  product_code: string;
  cas_no: string;
  productAlias: string;
  productNodes: string;
  additionalSupplier: string;
  exemptionclassFlag: string;
  internal: string;
}

export interface SearchCloudSDSObject {
  productName: string;
  productNameFilter: string;
  productCode: string;
  productCodeFilter: string;
  mfgName: string;
  mfgNameFilter: string;
  none: string;
  hazardClasses: string[],
  locationId: number[];
  pageNumber: number;
  pageSize: number;
  sortDirection: string;
}

export interface searchObject {
  searchProductName: string;
  searchProductCode: string;
  searchMfgName: string;
  searchCasNumber: string;
}

export interface InventoryModel {
  productId: number;
  msds_id: string;
  ref_id: string;
  cas_no: string[];
  product_code_array: string[];
  additionalSuppliers: string;
  synonyms: string;
  productAlias: string;
  rootAuthorityUnitId: number;
  product_name: string;
  mfg_name: string;
  product_code: string;
  addedToInventory: boolean;
  revision_date: string;
  last_verified: string;
  discontinued: boolean;
  whmis_exempt: boolean;
  position: number;
}

export interface AddAPIProducts {
  msdsId: string;
  productName: string;
  productCode: string;
  casNumber: string;
  manufacturerId: number;
  additionalSupplier: string;
  productAlias: string;
}


export interface Pokemon {
  value: string;
  viewValue: string;
}

export interface PokemonGroup {
  disabled?: boolean;
  name: string;
  hazardClass: any;
}

export interface CategoryType {
  name: string;
  hazardId: number;
  value: string;
}